import { useCallback, useEffect, useState } from 'react';
import style from './FsCampaignFooter.module.scss';
import { useFsVariationsToForceContext, useShowToast } from '@src/application/modules/flagship/hooks/fsHooks';
import { MSG_NAME_FROM_IFRAME, sendMessageFromIframe } from '@src/container/handleIframeMessage/handleIframeMessage';
import { removeForcedVariationsInStorage, saveForcedVariations } from '@application/modules/flagship/utils';
import { addVariationToForce, clearVariationsToForce } from '../../../fsData/fsActionCreators';
import { useTranslation } from 'react-i18next';
import { Button } from '@abtasty/design-system';

export const FsCampaignFooter = () => {
  const { fsVariationToForceState, dispatchFsVariationToForce } = useFsVariationsToForceContext();
  const [disabledApplyBtn, setDisabledApplyBtn] = useState(true);
  const { variationsToForce, variationsToForceTemp } = fsVariationToForceState;
  const showToast = useShowToast();
  const { t } = useTranslation();
  const variationsToForceTempCount = Object.keys(variationsToForceTemp).length;
  const hasVariationsToForceTemp = variationsToForceTempCount === 0;
  const hasVariationsToForce = Object.keys(variationsToForce).length === 0;

  useEffect(() => {
    if (!hasVariationsToForceTemp) {
      setDisabledApplyBtn(false);
    }
  }, [variationsToForceTemp]);

  const onApplyVariation = () => {
    const variationsToApply = { ...variationsToForce, ...variationsToForceTemp };
    sendMessageFromIframe({
      name: MSG_NAME_FROM_IFRAME.FsApplyForcedVariations,
      value: variationsToApply,
    });
    saveForcedVariations(variationsToApply);
    dispatchFsVariationToForce(addVariationToForce(variationsToForceTemp));
    setDisabledApplyBtn(true);
    showToast({ type: 'SUCCESS', text: t('Selected variations successfully applied') });
  };

  const onResetForcedVariations = useCallback(() => {
    sendMessageFromIframe({
      name: MSG_NAME_FROM_IFRAME.FsResetForcedVariations,
    });
    removeForcedVariationsInStorage();
    dispatchFsVariationToForce(clearVariationsToForce());
    setDisabledApplyBtn(true);
    showToast({ type: 'SUCCESS', text: t('Initial state successfully applied') });
  }, []);

  return (
    <div className={style.fsCampaignFooter}>
      <Button
        disabled={disabledApplyBtn}
        type="button"
        className={`${style.btn}`}
        onClick={onApplyVariation}
        size="small"
      >
        Apply variation(s)
      </Button>
      <Button
        disabled={hasVariationsToForceTemp && hasVariationsToForce}
        type="button"
        className={`${style.btn}`}
        variant="outlined"
        onClick={onResetForcedVariations}
        size="small"
      >
        Back to initial state
      </Button>
    </div>
  );
};
